import { Action } from '@/_core/fluxstore/types';
import { CurrentWsState } from '../types';
import { useCurrentWsStore } from '../useModule';

const { registerReducer } = useCurrentWsStore();

export class ChangeWorkspaceName extends Action<CurrentWsState> {
    public static ACTION_TYPE = 'ChangeWorkspaceName';
    public constructor(public name: string) {
        super(ChangeWorkspaceName.ACTION_TYPE);
    }
}


const reducer = (state: CurrentWsState, action: ChangeWorkspaceName): void => {
    state.name = action.name;
};

//@ts-ignore
registerReducer(ChangeWorkspaceName.ACTION_TYPE, reducer);